import { alpha } from '@mui/material/styles';

import { ERROR, WHITE } from 'reservations/brand/constants';

export const getComponents = (
  fonts: string[] = [],
  palette: Record<string, any>,
  typography: Record<string, any>,
  theme: Record<string, any>
) => ({
  MuiButton: {
    defaultProps: {
      disableElevation: true
    },
    styleOverrides: {
      root: {
        height: '48px',
        // TODO: Remove font and text overrides once we're ready
        fontWeight: 600,
        fontSize: '16px',
        textTransform: 'uppercase',
        width: '100%',
        padding: '0 20px',
        backgroundColor: palette.button?.background.main,
        color: palette.button?.font.main,
        ...(palette.button?.border?.main && {
          border: `1px solid ${palette.button.border.main}`
        }),
        '&:hover': {
          backgroundColor: palette.button?.background.hover,
          color: palette.button?.font.hover,
          ...(palette.button?.border?.hover && {
            border: `1px solid ${palette.button.border.hover}`
          })
        },
        '&.Mui-disabled': {
          opacity: 0.6
        },
        [theme.breakpoints.up('sm')]: { width: 'fit-content' },
        variants: [
          { props: { variant: 'primary' } },
          {
            props: { variant: 'secondary' },
            style: {
              backgroundColor: 'transparent',
              border: `1px solid ${palette.button?.background.main}`,
              color: palette.button?.background.main,
              '&:hover': {
                backgroundColor: alpha(palette.button?.background.main, 0.05),
                border: `1px solid ${palette.button?.background.main}`,
                color: palette.button?.background.main
              },
              '&:active': {
                backgroundColor: alpha(palette.button?.background.main, 0.1),
                border: `1px solid ${palette.button?.background.main}`,
                color: palette.button?.background.main
              }
            }
          },
          {
            props: { variant: 'error' },
            style: {
              backgroundColor: 'transparent',
              border: `1px solid ${palette.error.main}`,
              color: palette.error.main,
              '&:hover': {
                backgroundColor: alpha(palette.error.main, 0.05),
                border: `1px solid ${palette.error.main}`,
                color: palette.error.main
              },
              '&:active': {
                backgroundColor: alpha(palette.error.main, 0.1),
                border: `1px solid ${palette.error.main}`,
                color: palette.error.main
              }
            }
          },
          {
            props: { variant: 'darkMode' },
            style: {
              backgroundColor: 'transparent',
              border: `1px solid ${WHITE}`,
              color: WHITE,
              '&:hover': {
                backgroundColor: alpha(WHITE, 0.05),
                border: `1px solid ${WHITE}`,
                color: WHITE
              },
              '&:active': {
                backgroundColor: alpha(WHITE, 0.1),
                border: `1px solid ${WHITE}`,
                color: WHITE
              }
            }
          },
          {
            props: { variant: 'darkModeError' },
            style: {
              backgroundColor: 'transparent',
              border: `1px solid ${ERROR}`,
              color: ERROR,
              '&:hover': {
                backgroundColor: alpha(ERROR, 0.05),
                border: `1px solid ${ERROR}`,
                color: ERROR
              },
              '&:active': {
                backgroundColor: alpha(ERROR, 0.1),
                border: `1px solid ${ERROR}`,
                color: ERROR
              }
            }
          },
          {
            props: { size: 'fullWidth' },
            style: {
              [theme.breakpoints.up('sm')]: { width: '100%' }
            }
          },
          {
            props: { size: 'fixedWidth' },
            style: {
              width: 'fit-content'
            }
          }
        ]
      }
    }
  },
  MuiLink: {
    styleOverrides: {
      root: {
        color: palette.link?.main,
        '&:hover': {
          color: palette.link?.hover
        }
      }
    }
  },
  MuiCssBaseline: {
    styleOverrides: fonts.join('\n')
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: typography.body1.color
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: typography.body1.color
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: typography.body1.color
        }
      },
      input: {
        padding: '14px 12px',
        '&:-webkit-autofill, -webkit-autofill:focus, -webkit-autofill:hover': {
          WebkitTextFillColor: typography.body1.color,
          WebkitBoxShadow: `0 0 0px 1000px ${palette.background.default} inset`
        }
      }
    }
  },
  MuiList: {
    styleOverrides: {
      root: {
        backgroundColor: palette.background.default
      }
    }
  },
  MuiCalendarPicker: {
    styleOverrides: {
      root: {
        backgroundColor: palette.background.default
      }
    }
  },
  MuiCheckbox: {
    styleOverrides: {
      root: {
        color: palette.button?.background.main,
        '&.Mui-checked': {
          color: palette.button?.background.main
        }
      }
    }
  },
  MuiRadio: {
    styleOverrides: {
      root: {
        '&, &.Mui-checked, &.Mui-disabled': {
          color: typography.body1.color
        }
      }
    }
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        marginTop: '-2px'
      }
    }
  }
});
